import { dayjsWithTimezone, getFixedZoneTime } from '@/utils/intl/dateTimeFormatters'
import { dateFormat } from '@constants/dateFormat'
import { ErrorNotification } from '@gravitate-js/excalibrr'

export const handleDropValidation = (drops) => {
  let noErrors = true
  drops.forEach((d) => {
    if ((d.unit === 'in' && d.start_inches > d.end_inches) || (d.unit === 'volume' && d.start_volume > d.end_volume)) {
      const message = {}
      message.errorFields = [{ errors: ['Start Reading must be less than End Reading'] }]
      ErrorNotification(message)
      noErrors = false
    }
  })

  return noErrors
}
export const clearRowProduct = (form, field, name) => {
  const fields = form.getFieldsValue()
  const drops = fields[name]

  Object.assign(drops[field.name], { product: undefined, tank_id: undefined })
  const newObject = {}
  newObject[name] = drops
  form.setFieldsValue({ ...newObject })
}
export const setFormProduct = (product, form, field, name) => {
  const fields = form.getFieldsValue()
  const drops = fields[name]
  Object.assign(drops[field.name], { product })
  const newObject = {}
  newObject[name] = drops
  form.setFieldsValue({ ...newObject })
}

export const createBolRequest = (detail, name, timezone: Intl.DateTimeFormatOptions['timeZone']) => {
  const bols = []
  detail[name].forEach((d) => {
    const day = dayjsWithTimezone(d.date, timezone).format(dateFormat.DATE)
    const time = dayjsWithTimezone(d.time, timezone).format(dateFormat.TIME)
    const bol = {
      order_id: detail.order_id,
      bol_id: d.key,
      site: d.site,
      number: d.number,
      type: d.type.toLowerCase(),
      date: getFixedZoneTime(`${day} ${time}`, timezone).toISOString(),
      location: d.location,
    }
    bol.details = []
    d.details.forEach((x) => {
      bol.details.push({
        supplier: x.supplier,
        product: x.product,
        contract: x.contract,
        net: x.net,
        gross: x.gross,
        compartment_index: x.pocket ? parseInt(x.pocket) - 1 : null,
        price_type: x.price_type,
      })
    })
    bols.push(bol)
  })

  return bols
}

export const createDropRequest = (detail, name, timezone: Intl.DateTimeFormatOptions['timeZone']) => {
  const drops = []
  detail[name].forEach((d) => {
    const day = dayjsWithTimezone(d.date, timezone).format(dateFormat.DATE)
    const time = dayjsWithTimezone(d.time, timezone).format(dateFormat.TIME)
    drops.push({
      order_id: detail.order_id,
      uuid: d.key,
      store: d.store,
      product: d.product,
      tank_id: d.tank_id,
      date: getFixedZoneTime(`${day} ${time}`, timezone).toISOString(),
      start_inches: d.start_inches,
      start_volume: d.start_volume,
      water_inches: d.water_inches,
      end_inches: d.end_inches,
      end_volume: d.end_volume,
      volume: d.quantity,
      quantity: d.quantity,
      delete: d.delete,
      unit: d.unit,
    })
  })
  return drops
}
